import { useEffect } from 'react'
import { useState } from 'react';
import { TesCarousel } from '../components/TesCarousel'
import { Link } from 'react-router-dom'
import './Home.css'
import { Helmet } from 'react-helmet-async';

export default function Home() {
  const logos = [
    { src: "https://africantraveltour.com/assets/img/4-days-queen-elizabeth-np-safari.jpg", alt: "Tourism Regulatory Authority" },
    { src: "https://africantraveltour.com/assets/img/balloon-safari.jpg", alt: "Tripadvisor" },
    { src: "https://africantraveltour.com/assets/img/6-days-tanzania-safari.jpg", alt: "Safari Bookings" },
    { src: "https://africantraveltour.com/assets/img/8-days-tanzania-safari.jpg", alt: "Safarigo" },
    { src: "https://africantraveltour.com/assets/img/7-days-tanzania-safari.jpg", alt: "Safarigo" },
    { src: "https://africantraveltour.com/assets/img/6-days-kenya-classic-safari.jpg", alt: "Safarigo" },
    { src: "https://africantraveltour.com/assets/img/4-days-3-nights-amboseli-tsavo-west-tsavo-east-national-parks.jpg", alt: "Safarigo" },
  ];
  const [bgImage, setBgImage] = useState(
    "https://redlionandcompany.com/Assets/kamarezOfArica/kamarezserviceimg-small.png"
  ); // low-res placeholder
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = "https://redlionandcompany.com/Assets/kamarezOfArica/kamarezserviceimg.png"; // full-res
    img.onload = () => {
      setBgImage(img.src);
      setIsLoaded(true);
    };
  }, []);






  const Destinationcards = [
    {
      title: "Rwanda",
      img: "https://africantraveltour.com/assets/img/aftt-np-hp-2.webp",
    },
    {
      title: "Uganda",
      img: "https://africantraveltour.com/assets/img/aftt-np-hp-7.webp",
    },
    {
      title: "Kenya",
      img: "https://africantraveltour.com/assets/img/aftt-np-hp-8.webp",
    },
    {
      title: "Tanzania",
      img: "https://africantraveltour.com/assets/img/aftt-np-hp-1.webp",
    },
  ];


  return (
    <div style={{
      position: "relative",
      zIndex: 100,
      backgroundImage: "var(--bg-image)",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}>
      <Helmet>
        <title>African Travel Tour | Tanzania & East Africa Safari Experts</title>
        <meta
          name="description"
          content="Plan your dream safari with African Travel Tour. Expertly guided Tanzania and East Africa safaris, luxury getaways, cultural adventures, and tailor-made travel experiences."
        />
        <meta
          name="keywords"
          content="Tanzania safari, East Africa safaris, tailor-made safaris, Maasai Mara, Diani beach, luxury safari, African travel experiences"
        />
        <meta property="og:title" content="African Travel Tour | Tanzania & East Africa Safari Experts" />
        <meta property="og:description" content="Unforgettable safaris and adventures across Tanzania and East Africa. Experience wildlife, culture, and luxury travel with African Travel Tour." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://africantraveltour.com" />
      </Helmet>



      <div className="video-section position-relative overflow-hidden">
        {/* Background Video */}
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-100 h-auto d-block"
          style={{ objectFit: 'cover' }}
        >
          <source src="https://redlionandcompany.com/Assets/kamarezOfArica/SafarisAfricanTourVideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Overlay for small devices */}
        <div className="d-block d-lg-none  text-white text-center py-2">


        </div>

        <div className="video-overlay position-absolute top-0 start-0 w-100 h-100 d-none d-lg-block"></div>

        {/* Overlay Content */}
        <div className="position-absolute top-50 start-50 translate-middle z-1 w-100 px-3 container d-none d-lg-block" style={{ maxWidth: '1400px' }}>
          <div className="row w-100 justify-content-between align-items-center">

            {/* Text Content */}
            <div className=" text-white text-center mb-4 mb-lg-0 ">
              <h1 className="display-3 mb-3 animated slideInDown" style={{ color: "#cd9015" }}>
                Your Safari, Perfectly Designed
              </h1>
              <p className="fs-4 mb-4 animated slideInDown ">
                Experience Tanzania's most iconic safaris, crafted just for you.
              </p>
              <Link to='/safaris_packages' className='btn btn-primary rounded-pill ms-lg-4 py-3 px-4 shadow-sm text-white' >Start Customizing </Link>
            </div>
          </div>
        </div>
      </div>


      <section className="welcomesection d-flex align-items-center justify-content-center text-white py-5">
        

        <div className="container text-center text-md-start position-relative py-5">

          <div className="d-flex display-column align-items-center justify-content-center hero-section-mobile-margin px-3 ">

            <div className="col-md-7">
              <div className=" text-center">
                <h2 className="section-header mb-5 " >
                  <span className="accent pulse-button" >
                    Welcome to

                  </span>
                  <br />
                  African Travel Tour
                </h2>
              </div>

              <p className="mb-4" style={{
                textAlign: "justify",
                textAlignLast: "center",
                color: "#7a2304ff"


              }}>
                African Travel Tour is a tour, travel and safari company legally incorporated in Tanzania and operating in the entire East Africa. We offer Wildlife safaris, Gorilla Safaris, Bird Watching Safaris, Mountain Hiking, Chimpanzee trekking, Cultural Tours, Guided Nature walks, airport transfers and Customized Tours in Tanzania.For over a period of 10 good years, we have provided the highest quality service at a reasonable cost. Our expert guides, quality standards and focus on safety have made us the top choice for thousands of happy customers from all over the world.

              </p>

            </div>
          </div>
        </div>
      </section>
      




      {/* About Start */}
      <div className="pb-5">

        <div className=" d-flex flex-column align-items-center px-0 mx-0  ">

          <div className="logo-slider-container">
            <div
              className="logo-slider"
              style={{ '--logo-count': logos.length }}
            >
              {logos.concat(logos).map((logo, i) => (
                <div className="logo-slide" key={i}>
                  <img loading="lazy" src={logo.src} alt={logo.alt} />
                </div>
              ))}
            </div>
          </div>



        </div>

      </div>
      {/* About End */}

      {/* Categories 
      <div className=" pt-4 pb-5 my-5 d-flex flex-column justify-content-center align-items-center">
        <div className="text-center my-5 d-flex flex-column justify-content-center align-items-center">
          <h2 className="section-header">
            <span className="accent pulse-button">
              <ReactTyped
                strings={["Our popular tours"]}
                typeSpeed={90}
                backSpeed={90}
                showCursor={true}
                loop
              />
            </span>
            <br />
            African Travel Experiences
          </h2>
          <div className='aboutUs-Intro pt-4 wow fadeInUp '>
            <p className='text-center'>
              Explore Africa’s most iconic adventures from classic wildlife safaris to scenic flying adventures and breathtaking hikes.
            </p>

          </div>
        </div>
        <div className="row g-1">
          {cards.map((card, index) => (
            <div className="col-md-4 d-flex wow fadeInUp justify-content-center" data-wow-delay={card.delay} key={index} >
              <Link to={card.link} className="text-decoration-none">
                <div className="safari-card position-relative">
                  <img loading="lazy" src={card.img} alt={card.title} className="img-fluid w-100" />
                  <div className="overlay d-flex flex-column justify-content-center align-items-center">
                    <h3 className="text-white fw-bold text-center">{card.title}</h3>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      Start */}
      {/* Categories End */}
      {/* Package Start */}
      <div style={{ position: "relative", backgroundColor: "#b9922f17" }}>

        <div className="container-xxl py-5">
          <div className="container text-center">
            <h2 className="section-header section-header-bigger-heihgt my-5 text-center">
              <span className="accent pulse-button">Discover Our</span>
              <br />
              best-seller Tanzania packages.
            </h2>

            <div className="row g-4 justify-content-center">
              {[
                { id: 4, title: "2 Days Tanzania safari", img: "https://africantraveltour.com/assets/img/2-days-tanzania-safaris.jpg", destination: "Tanzania ", duration: "2 Days 1 Nights", numberppl: "1-8 Person", price: "$900", description: "Experience the best of Northern Tanzania's wildlife in this compact 2-day safari adventure.", url: "/TwoDaysTanzaniasafari" },
                { id: 5, title: "3 Days Tanzania safari", category: 'Safaris', img: "https://africantraveltour.com/assets/img/3-days-tanzania-safari.jpg", destination: "Tanzania", duration: "3 Days 2 Nights", numberppl: "1-8 Person", price: "$1350", description: "Experience the ultimate Northern Tanzania safari adventure with this comprehensive 3-day tour.", url: "/ThreeDaysTanzaniaSafaris" },
                { id: 6, title: "4 Days Tanzania Safari", category: 'Safaris', img: "https://africantraveltour.com/assets/img/4-days-tanzania-safari.jpg", destination: "Tanzania", duration: "3 Days 2 Nights", numberppl: "1-8 Person", price: "$1800", description: "Embark on a 4-day safari adventure through two of Tanzania's most iconic national parks.", url: "/FourDaysTanzaniasafaris" },

              ].map((pkg) => (
                <div
                  key={pkg.id}
                  className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                  data-wow-delay="0.1s"
                >
                  {/* Make entire card clickable */}
                  <a href={pkg.url} className="safari-card-link">
                    <div className="safari-card position-relative overflow-hidden">
                      {/* 🖼️ Image wrapper */}
                      <div className="safari-img-wrapper">
                        <img src={pkg.img} alt={pkg.title} className="safari-img" />
                        <div className="safari-dark-layer"></div>
                      </div>

                      {/* Price Badge */}
                      <div
                        className="position-absolute top-0 end-0 m-3 px-3 py-2 fw-bold text-dark safari-price"
                      >
                        From {pkg.price}*
                      </div>

                      {/* Orange top overlay (on hover) */}
                      <div className="safari-top-overlay d-flex flex-column align-items-center justify-content-center text-center text-dark px-3 pb-5">
                        <h5 className="fw-bold mb-2">{pkg.title}</h5>
                        <p className="">{pkg.description}</p>
                        <p className='text-decoration-underline mb-4'>Read More</p>


                      </div>

                      {/* Bottom overlay (visible by default) */}
                      <div
                        className="text-white text-center p-4 safari-bottom-overlay"
                      >
                        <h4 className="fw-bold mb-2" style={{ color: '#ffc247ff' }}>{pkg.title}</h4>
                        <p className="mb-3">{pkg.description}</p>
                        <p className='text-decoration-underline'>Read More</p>


                      </div>
                    </div>
                  </a>
                </div>

              ))}
            </div>

            <div className="mt-5">
              <a
                href="/safaris_packages"
                className="btn btn-outline-success px-4 py-2 safari-discover-btn"
              >
                Discover More
              </a>
            </div>
          </div>
        </div>



      </div>
      {/* Package End */}


      {/* Destination Start */}
      <div className="container-xxl py-5 destination">
        <div className="container">
          <h2 className="section-header mb-5 text-center">
            <span className="accent pulse-button">
              Discover Our
            </span>
            <br />
            Popular Destinations
          </h2>
          <div className="row g-4">
            {Destinationcards.map((card, index) => (
              <div key={index} className={`col-12 col-sm-6 col-lg-3 ${(index === 1 || index === 3) ? "pt-5" : ""
                }`}
              >
                <div className="card border-0 h-100 rounded-4 overflow-hidden" style={{ backgroundColor: 'transparent' }}>
                  <div className="position-relative">
                    <img loading="lazy"
                      src={card.img}
                      alt={card.title}
                      className="card-img-top img-fluid"
                      style={{ height: "300px", objectFit: "cover" }}
                    />
                    <span
                      className="position-absolute top-0 start-0 m-2 px-3 py-1 text-white rounded-pill fw-bold"
                      style={{ fontSize: "0.9rem", backgroundColor: '#446400' }}
                    >
                      {card.title}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Destination Start */}




      {/*Highlists Start 
      <SafariHighlights />
      */}




      {/* Testimonial Start  */}


      <div style={{ position: "relative", backgroundColor: "#b9922f17" }}>
        <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="container">
            <div className="text-center my-5">
              <h2 className="section-header">
                <span className="accent pulse-button">
                  Testimonials
                </span>
                <br />
                Our Clients Say !
              </h2>
            </div>

            <div className="d-flex align-items-center justify-content-center">
              <TesCarousel />
            </div>
          </div>
        </div>
      </div>
      {/*Testimonial End */}
      {/*Accredation Start */}
      <div className="container pt-4 pb-5 mt-5">
        <div className="text-center my-5">
          <h2 className="section-header section-header-bigger-heihgt">
            <span className="accent pulse-button">
              Our Accreditations
            </span>
            <br />
            We are licensed, accredited, or partner with
          </h2>
        </div>
        <div className="row g-4 py-5">

          <div className="col-md-2 d-flex justify-content-center wow fadeInUp" >
            <img loading="lazy" src="https://africantraveltour.com/assets/img/brand-logo-1.webp" alt='tra' className="img-fluid " style={{ width: '200px' }} />
          </div>
          <div className="col-md-2 d-flex justify-content-center wow fadeInUp" data-wow-delay="0.3s">
            <img loading="lazy" src="https://africantraveltour.com/assets/img/yrtpt-logo-2.webp" alt='tripAdvisor' className="img-fluid " style={{ width: '200px' }} />
          </div>
          <div className="col-md-2 d-flex justify-content-center wow fadeInUp" data-wow-delay="0.5s">
            <img loading="lazy" src="https://africantraveltour.com/assets/img/yrtpt-logo-3.webp" alt='tra' className="img-fluid " style={{ width: '200px' }} />
          </div>
          <div className="col-md-2 d-flex justify-content-center wow fadeInUp" data-wow-delay="0.7s">
            <img loading="lazy" src="https://africantraveltour.com/assets/img/yrtpt-logo-5.webp" alt='tra' className="img-fluid " style={{ width: '200px' }} />
          </div>
          <div className="col-md-2 d-flex justify-content-center wow fadeInUp" data-wow-delay="0.7s">
            <img loading="lazy" src="https://africantraveltour.com/assets/img/brand-logo-2.webp" alt='tra' className="img-fluid " style={{ width: '200px' }} />
          </div>
          <div className="col-md-2 d-flex justify-content-center wow fadeInUp" data-wow-delay="0.7s">
            <img loading="lazy" src="https://africantraveltour.com/assets/img/brand-logo-3.webp" alt='tra' className="img-fluid " style={{ width: '200px' }} />
          </div>


        </div>
      </div>
      {/*Accredation end */}
    </div>
  )
}
